import type { SVGProps } from 'react';

type Props = { width?: number; height?: number; color?: string; primary_color?: string } & SVGProps<SVGSVGElement>;

export const SVG = (props: Props) => (
  <svg width={props.width} height={props.height} viewBox='0 0 27 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.78571 9.20312V9.6875H2.89286V9.20312C2.89286 4.12324 6.9971 0 12.0536 0H14.9464C20.0029 0 24.1071 4.12324 24.1071 9.20312V9.6875H21.2143V9.20312C21.2143 5.72773 18.4058 2.90625 14.9464 2.90625H12.0536C8.5942 2.90625 5.78571 5.72773 5.78571 9.20312ZM0 13.5625C0 12.4908 0.86183 11.625 1.92857 11.625H25.0714C26.1382 11.625 27 12.4908 27 13.5625C27 14.6342 26.1382 15.5 25.0714 15.5H24.7641L23.4141 28.3965C23.2574 29.8738 22.0158 31 20.5393 31H6.46071C4.97812 31 3.73661 29.8799 3.58594 28.3965L2.23594 15.5H1.92857C0.86183 15.5 0 14.6342 0 13.5625Z'
      fill={props?.primary_color || 'white'}
    />
    <path
      d='M14.4286 16.875C14.4286 16.391 14.0455 16 13.5714 16C13.0973 16 12.7143 16.391 12.7143 16.875V20.8125H8.85714C8.38304 20.8125 8 21.2035 8 21.6875C8 22.1715 8.38304 22.5625 8.85714 22.5625H12.7143V26.5C12.7143 26.984 13.0973 27.375 13.5714 27.375C14.0455 27.375 14.4286 26.984 14.4286 26.5V22.5625H18.2857C18.7598 22.5625 19.1429 22.1715 19.1429 21.6875C19.1429 21.2035 18.7598 20.8125 18.2857 20.8125H14.4286V16.875Z'
      fill={props?.color || 'black'}
    />
  </svg>
);

export default SVG;
